(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {
  $('#menu').css('padding-top', $('.header').height() + 40 + 'px');
  $('.mob-heading').click(function () {
      //$(this).next().toggleClass('mob-show');
      $(this).next().slideToggle(200);
      $(this).parent().toggleClass("expanded");
  });
  $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-getting-started"]) return;
  try {
    
$(document).ready(function() {

	//Set the initial state: highlight the first button...
	$('.tabs').find('li:eq(0)').addClass('active');

	//and hide all tab content except the first one
	$('.tab-content').find('> div.tab:eq(0)').nextAll().hide();

	//actions that apply on click of any of the buttons
	$('.tabs li').click( function(event) {

		//turn off the link so it doesn't try to jump down the page
		event.preventDefault();

		//un-highlight the buttons
		$('.tabs li').removeClass();

		//hide all the slides
		$('.tab-content > .tab').hide();

		//highlight the current button
		$(this).addClass('active');

        $('.tab-content > .tab:eq('+index+') > .js-tab-collection').slick('setPosition');

		//get the index of the current button...
		var index = $('.tabs li').index(this);
        console.log(index);

		//and use that index to show the corresponding slide
        $('.tab-content > .tab:eq('+index+')').addClass('opened');
		$('.tab-content > .tab:eq('+index+')').show();

	});

    $(window).on("load resize", function (e) {
        if ( $(window).width() < 960 ) {
            resizeSlider();
        }
    });
      
    function resizeSlider() {
        var slickHeight = $(".slick-track").outerHeight();
        console.log(slickHeight);
        var slideHeight = $(".slick-track").find(".slick-slide").outerHeight();
        console.log(slideHeight);
        $(".slick-track").find(".slick-slide").css("height", slickHeight + "px");
    }; 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-success-stories"]) return;
  try {
    
    $(window).on('load', function(){
        var $sliderHeight = 0;
        
        $('.js-success-stories-slider .plyr--video').each(function() {
            if ( $(this).height() > $sliderHeight ) {
                $sliderHeight = $(this).height();
                console.log("Go robot");
            }
        });
        $('.js-success-stories-slider .plyr--video').each(function(){
            $(this).css('max-height', $sliderHeight);
            $(this).find('iframe').css('max-height', $sliderHeight);
            $(this).find('video').css('max-height', $sliderHeight);
        });
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
        $(this).children('.plus-minus-toggle').toggleClass('collapsed');
    });
    $('.answer').slideUp(200);
   
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related-products"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
